import {
  ASSET_ASSIGNED,
  CONNECTION_TYPE,
  TEAMS,
} from "~/constants/filters/filters";
import { isCustomFieldFilter } from "~/utils/filter/customFieldFilterValue";

export const defaultFilters = {
  [ASSET_ASSIGNED]: [],
  [TEAMS]: [],
  [CONNECTION_TYPE]: [],
};

const applyFilters = (activeFilters = defaultFilters, _filter) => {
  if (
    activeFilters[_filter]?.length > 0 ||
    typeof activeFilters[_filter] === "boolean"
  ) {
    return activeFilters[_filter];
  } else {
    return undefined;
  }
};

export const generateFacilitiesQueryWhereCond = (
  activeFilters = defaultFilters,
  searchValue = "",
) => {
  const customFields = [];
  for (const filter of Object.keys(activeFilters)) {
    if (
      !defaultFilters[filter] &&
      isCustomFieldFilter(filter, activeFilters[filter])
    ) {
      customFields.push({
        fieldId: filter,
        value: activeFilters[filter],
      });
    }
  }

  const machine_assigned = applyFilters(activeFilters, ASSET_ASSIGNED);

  const teams_in = applyFilters(activeFilters, TEAMS);

  const connection_type = applyFilters(activeFilters, CONNECTION_TYPE);

  return {
    ...(machine_assigned !== undefined ? { machine_assigned } : {}),
    ...{ name_contains: searchValue },
    ...(teams_in ? { teams_in } : {}),
    ...(connection_type ? { connectionType: connection_type } : {}),
    ...(customFields?.length ? { customFields } : {}),
  };
};
